import React from 'react'
import {Link } from 'react-router-dom'
import {
  Button,
} from 'reactstrap'
import './Book.scss'

function Book({ alt, title, image, detailImage, link, newRelease = false }) {
  return (
    <div className="Book d-flex flex-column align-items-center">
      <Link to={`/books/${title}`}>
        <img className="img-fluid rounded" src={ `/images/${newRelease ? detailImage : image}` } alt={ alt } />
      </Link>
      <Button className="mt-4" target="_blank" tag="a" href={ link } outline size="lg">Buy On Amazon</Button>
    </div>
  )
}

export default Book
